import { forwardRef, useEffect } from 'react'
import { useRequestsStore } from '../../store/storeRequests'
import { useWrapperStore } from '../../store/storeWrapper'
import { RequestInput } from './RequestInput'

interface Props {
    suggestedRequest?: string
    onMounted?: VoidFunction
    onSendMessage?: VoidFunction
}

export const WrapperRequestInput = forwardRef<HTMLDivElement, Props>(
    ({ suggestedRequest, onMounted, onSendMessage }, ref) => {
        const { requestDetail, errorRequestDetail } = useRequestsStore()
        const { isUpdateCreatedRequest } = useWrapperStore()
        const { projectListActive, fetchModelDetail, modelDetail } = useWrapperStore()

        useEffect(() => {
            if (requestDetail?.agent || requestDetail?.assistant_id) {
                fetchModelDetail(requestDetail.agent, requestDetail.assistant_id)
            }
        }, [requestDetail?.agent, requestDetail?.assistant_id])

        const isInputReadyToMount =
            !errorRequestDetail &&
            ((!isUpdateCreatedRequest && modelDetail && modelDetail.is_restricted === false) ||
                isUpdateCreatedRequest) &&
            projectListActive

        useEffect(() => {
            if (isInputReadyToMount) {
                onMounted?.()
            }
        }, [isInputReadyToMount])

        return (
            <RequestInput
                ref={ref}
                isNewRequest={true}
                isArchivedRequest={requestDetail?.is_archived}
                suggestedRequest={suggestedRequest}
                disabled={requestDetail?.is_archived || !isInputReadyToMount}
                onSendMessage={onSendMessage}
            />
        )
    },
)
